function Animation() {
  this.pulseAmount = function(target) {
    target.removeClass('pulse-amount')
    setTimeout(function () {
      target.addClass('pulse-amount')
    }, 100)
  }
}